export interface CustomRange {
  startContainer: Node;
  endContainer: Node;
  startOffset: number;
  endOffset: number;
  toString: () => string;
}

export enum LayoutSizes {
  extraSmall = 1,
  small = 2,
  medium = 3,
  large = 4,
  extra = 5,
  extraExtra = 5,
}
